export enum WebsiteFont {
    MONTSERRAT = 'montserrat',
    GEIST_MONO = 'geist_mono',
    GILDA_DISPLAY = 'gilda_display',
    HANKEN_GROTESK = 'hanken_grotesk'
}
